import { createContext} from "react";

export const SecondaryNavigationContext = createContext([]);